import { sanitizeAmp } from '~/libs/sanitize-amp';

export const processingQuiz = (content: TContent): TContent => {
  return {
    ...content,
    attributes: { ...content.attributes, content: sanitizeAmp(content.attributes.content) },
  };
};
